module.exports = __webpack_public_path__ + "static/media/connectionWarning.ac6fe03b.mp3";